<template>
  <v-container class="pa-0">

    <v-expansion-panels
      class="mb-3 elevation-1"
      focusable
      :value="0"
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          Filters
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-4">
            <v-col cols="12" md="4">
              <v-select
                v-model="search.field"
                :items="filterOptions"
                item-text="label"
                item-value="id"
                dense
                outlined
                hide-details
              >

              </v-select>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="search.value"
                clearable
                dense
                outlined
                label="Value"
                hide-details
                @keyup.enter="onSearch"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-btn
                outlined
                rounded
                color="primary"
                @click="onSearch"
              >
                Search
              </v-btn>
            </v-col>


          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-data-table
      class="elevation-1"
      :headers="headers"
      :items="items"
      :loading="isLoading"
      :loading-text="'Loading customers...'"
      hide-default-footer
      :items-per-page="limit"
    >
      <template v-if="!isLoading" v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id"
              @click="onClick(item)"
              style="cursor: pointer"
          >
            <td>
              {{ item.name}}
            </td>
            <td>
              {{ item.phone }}
            </td>
            <td>
              {{ item.email }}
            </td>
            <td class="text-right">
              {{ formatDate(item.created) }}

            </td>
          </tr>
        </tbody>
      </template>

      <template v-slot:footer="{}">
        <v-divider/>
        <v-layout>
          <span/>
          <v-spacer/>
          <v-btn
            icon
            :disabled="isLoading || disablePrev()"
            @click="prevPage()"
          >
            <v-icon>navigate_before</v-icon>
          </v-btn>
          <v-btn
            icon
            :disabled="isLoading || disableNext()"
            @click="nextPage()"
          >
            <v-icon>navigate_next</v-icon>
          </v-btn>
        </v-layout>
      </template>
    </v-data-table>

  </v-container>
</template>
<script>
import { get, isEmpty } from 'lodash'
import { unixDateDiff, convertTimestampToDate } from "../../services/util.service"

import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    emitSelected: {
      type: Boolean,
      default: false
    },
    performInitSearch: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    ...mapActions([ 'searchCustomers' ]),
    onClick(customer) {
      if (this.emitSelected) {
        this.$emit('selected-customer', customer)
      } else {
        this.$router.push({ name: 'customer-detail', params: { id: customer.id } })
      }
    },
    onSearch(){
      this.startAt = null
      this.startAfter = null
      this.nextPage()
    },
    onCancelAction() {
      this.reloadPage()
    },
    formatDate(created) {
      return moment(convertTimestampToDate(created)).format('LL')
    },
    disablePrev() {
      return false //isEmpty(this.endBefore)
    },
    disableNext() {
      return false //isEmpty(this.startAfter)
    },
    reloadPage() {
      const firstItemId = get(this.items, '[0].id')

      if (!isEmpty(firstItemId)) {
        this.items = []
        this.isLoading = true
        const payload = {
          id: this.id,
          pagination: {
            limit: this.limit,
            startAt: firstItemId
          },
          search: { ...this.search }
        }

        this.searchCustomers(payload)
          .then(res => {
            const { data } = res
            this.items = [ ...data ]
          })
          .finally(() => {
            this.isLoading = false
          })
      }

    },
    nextPage() {
      this.isLoading = true
      this.items = []

      const payload = {
        id: this.id,
        pagination: {
          limit: this.limit,
          startAfter: this.startAfter,
          startAt: this.startAt
        },
        search: { ...this.search }
      }

      this.searchCustomers(payload)
        .then(res => {
          const { data } = res
          this.items = [ ...data ]

          if (data.length > 0) {
            this.endBefore = get(data, '[0].id')
            this.startAfter = get(data, `[${data.length - 1}].id`)
          } else {
            this.endAt = this.startAfter
            this.endBefore = null
            this.startAfter = null
          }

        })
        .finally(() => {
          this.isLoading = false
        })
    },
    prevPage() {
      this.isLoading = true
      this.items = []

      const payload = {
        id: this.id,
        pagination: {
          limitToLast: this.limit,
          endBefore: this.endBefore,
          endAt: this.endAt
        },
        search: { ...this.search }
      }

      this.searchCustomers(payload)
        .then(res => {
          const { data } = res
          this.items = [ ...data ]

          if (data.length > 0) {
            this.endBefore = get(data, '[0].id')
            this.startAfter = get(data, `[${data.length - 1}].id`)
          } else {
            this.startAt = this.endBefore
            this.startAfter = null
            this.endBefore = null
          }

        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  data() {
    return {
      isLoading: false,
      items: [],
      limit: 25,
      endBefore: null,
      startAfter: null,
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
        },
        {
          text: 'Phone',
          sortable: false
        },
        {
          text: 'Email',
          sortable: false,
        },
        {
          text: 'Created',
          align: 'right',
          sortable: false,
        },
      ],
      search: {
        field: 'first_name',
        value: ''
      },
      filterOptions: [
        {
          id: 'first_name',
          label: 'First Name'
        },
        {
          id: 'last_name',
          label: 'Last Name'
        },
        // {
        //   id: 'phone',
        //   label: 'Phone'
        // },
        {
          id: 'email',
          label: 'Email'
        }
      ]
    }
  },
  mounted() {
    if (this.performInitSearch) {
      this.nextPage()
    }
  }
}
</script>
